const getListTokens = (tokens) => {
    return {
        listItem: tokens.component.listItem,
        checkbox: tokens.component.checkbox,
        button: tokens.component.button,
        spacing: tokens.semantic.spacing,
        borderWidth: tokens.semantic.borderWidth,
        color: tokens.semantic.color,
        shadow: tokens.semantic.shadow,
    };
};
const list = (tokens) => {
    const { listItem, button, spacing, checkbox, shadow } = getListTokens(tokens);
    const rightPaddingWithIconButton = `calc(${listItem.padding.value} + ${listItem.gap.value} + ${button.iconOnly.width.value})`;
    return {
        MuiList: {
            defaultProps: {
                disablePadding: true,
            },
            styleOverrides: {},
        },
        MuiListItem: {
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign({ gap: listItem.media.gap.value, padding: (ownerState === null || ownerState === void 0 ? void 0 : ownerState.disableGutters) || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.disablePadding) ? 0 : listItem.padding.value, backgroundColor: listItem.backgroundColor.value, 
                    // If there is a secondary action, used a <ListItemSecondaryAction /> child item,
                    // we get an extra class on the list item. We remove the list item padding,
                    // and make space for the button in a direct descendant text.
                    "&.MuiListItem-secondaryAction": {
                        paddingRight: 0,
                        "&>.MuiListItemText-root": {
                            paddingRight: rightPaddingWithIconButton,
                        },
                    } }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.secondaryAction) && {
                    paddingRight: (ownerState === null || ownerState === void 0 ? void 0 : ownerState.disablePadding) ? 0 : rightPaddingWithIconButton,
                    // and pass it to the button instead
                    "& > .MuiListItemButton-root": {
                        paddingRight: (ownerState === null || ownerState === void 0 ? void 0 : ownerState.disablePadding) ? rightPaddingWithIconButton : 0,
                    },
                })), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.divider) && {
                    borderBottom: `${listItem.bordered.borderBottomWidth.value} solid ${listItem.borderColor.value}`,
                }))),
            },
        },
        MuiListSubheader: {
            defaultProps: {
                disableGutters: true,
            },
            styleOverrides: {
                root: {
                    height: "unset",
                    fontSize: listItem.sectionHeader.fontSize.value,
                    color: listItem.sectionHeader.color.value,
                    lineHeight: listItem.lineHeight.value,
                    textTransform: "uppercase",
                    padding: listItem.padding.value,
                    "&:not(:first-of-type)": {
                        borderTop: `${listItem.sectionHeader.borderTopWidth.value} solid ${listItem.sectionHeader.borderTopColor.value}`,
                    },
                },
            },
        },
        MuiListItemText: {
            defaultProps: {
                disableTypography: true,
            },
            styleOverrides: {
                root: {
                    color: listItem.color.value,
                    margin: spacing.none.value,
                    fontSize: listItem.fontSize.value,
                    lineHeight: listItem.lineHeight.value,
                    paddingTop: listItem.text.paddingVertical.value,
                    paddingBottom: listItem.text.paddingVertical.value,
                    "& .MuiListItemText-primary": {
                        fontWeight: listItem.title.fontWeight.value,
                    },
                    "& .MuiListItemText-secondary": {
                        fontWeight: listItem.description.fontSize.value,
                        lineHeight: listItem.description.lineHeight.value,
                    },
                    "& .MuiTypography-root": {
                        fontSize: "inherit",
                        lineHeight: "inherit",
                        color: "inherit",
                    },
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: "auto",
                    "& > svg": {
                        width: listItem.icon.width.value,
                        height: listItem.icon.height.value,
                    },
                    "& .MuiCheckbox-root .MuiSvgIcon-root": {
                        width: checkbox.width.value,
                        height: checkbox.height.value,
                    },
                },
            },
        },
        MuiListItemAvatar: {
            styleOverrides: {
                root: {
                    right: listItem.padding.value,
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign({ gap: listItem.gap.value, borderRadius: 0, "&:hover": {
                        backgroundColor: listItem.hover.backgroundColor.value,
                    }, "&:active": {
                        backgroundColor: listItem.focus.backgroundColor.value,
                    }, "&:focus": {
                        backgroundColor: listItem.focus.backgroundColor.value,
                        boxShadow: shadow.focusInset.value.stringValue,
                    } }, (!(ownerState === null || ownerState === void 0 ? void 0 : ownerState.disableGutters) && {
                    // default
                    padding: listItem.padding.value,
                })), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.disableGutters) && {
                    // Used with "media"
                    paddingLeft: 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                }))),
            },
        },
    };
};
export default list;
//# sourceMappingURL=list.js.map